export const DEFAULT_TAB_TITLE = "C H R O N O S";

/** Below this width the layout is the phone one (bottom nav bar, stacked home). */
export const MOBILE_BREAKPOINT = 768;
export const MOBILE_MEDIA_QUERY = `(max-width: ${MOBILE_BREAKPOINT - 1}px)`;

export const TABLET_BREAKPOINT = 1024;
export const TABLET_MEDIA_QUERY = `(max-width: ${TABLET_BREAKPOINT - 1}px)`;
